import { Button } from "@mui/material";
import { styled } from "@mui/system";

const FormButtonNextStyled = styled(Button)(({ theme }) => ({
  minWidth: "40%",
  color: "#ffffff",
  backgroundColor: theme.palette.custom.btnBackground,
  borderRadius: "50px",
  border: "1px solid ${theme.palette.custom.btnBackground}",
  transition: "background-color 0.3s, color 0.3s, box-shadow 0.3s",
  textTransform: "none",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  "&:hover": {
    backgroundColor: "#ffffff",
    color: theme.palette.custom.blue,
    boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
  },
}));

export const FormButtonNext = ({ onNextStep, currentStep }) => {
  return (
    <FormButtonNextStyled onClick={() => onNextStep(currentStep + 1)}>
      Suivant
    </FormButtonNextStyled>
  );
};
